import type { StyleRule } from '@archipro-design/aria';
import {
    captionClassName,
    HeaderClassName,
    pxArrayToRem,
    pxToRem,
} from '@archipro-design/aria';

export const TitleContainer: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([16, 18, 16, 18]),
    [theme.screen.laptop]: {
        position: 'relative',
        padding: 0,
        display: 'flex',
        width: '100%',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        marginTop: pxToRem(32),
        marginBottom: pxToRem(24),
    },
});

export const Header: StyleRule = ({ theme }) => ({
    marginTop: 0,
    marginBottom: 0,
    [`&.${HeaderClassName}`]: {
        fontSize: pxToRem(20),
        lineHeight: theme.siteVariables.lineHeightDefault,
        letterSpacing: theme.siteVariables.letterSpacingMedium,
    },
    ...theme.siteVariables.textStyles.Heading.Medium65,
    textTransform: 'uppercase',
    [theme.screen.laptop]: {
        maxWidth: pxToRem(981),
        letterSpacing: theme.siteVariables.letterSpacingMedium,
        [`&.${HeaderClassName}`]: {
            fontSize: pxToRem(22),
            marginBottom: pxToRem(10),
        },
    },
});

export const SubHeader: StyleRule = ({ theme }) => ({
    color: theme.siteVariables.colors.grey['300'],
    marginTop: 0,
    marginBottom: pxToRem(6),
    [`&.${HeaderClassName}`]: {
        fontSize: theme.siteVariables.fontSizes['label02'],
        letterSpacing: theme.siteVariables.letterSpacingNormal,
        lineHeight: '130%',
    },
    ...theme.siteVariables.textStyles.Text.Roman55,
});

export const HeaderProfessionalLink: StyleRule = ({ theme }) => ({
    textUnderlineOffset: pxToRem(2),
    marginTop: pxToRem(6),
    color: theme.siteVariables.colors.charcoal['100'],
    display: 'inline-block',
    ...theme.siteVariables.textStyles.Text.Roman55,
    [`& a.${captionClassName}`]: {
        textDecoration: 'underline !important',
    },
    [theme.screen.tablet]: {
        marginTop: 0,
        display: 'inline',
        color: theme.siteVariables.colors.charcoal['300'],
    },
});

export const HeaderCTA: StyleRule = () => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
});

export const TopPaneContainer: StyleRule = () => ({
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 'auto',
});

export const LinkButton: StyleRule = () => ({
    textDecoration: 'underline',
    '& > span': {
        marginRight: pxToRem(10),
    },
});
const PAGE_HEADER_HEIGHT_EXPANDED = 235;
const PAGE_HEADER_INNER_HEIGHT_DEFAULT = 96;

export const ProductHeaderContainer: StyleRule<{
    innerHeight?: number;
    scrollY?: number;
}> = ({ theme, innerHeight, scrollY }) => {
    const isFloating = scrollY && scrollY > PAGE_HEADER_HEIGHT_EXPANDED;
    const height =
        innerHeight && innerHeight > PAGE_HEADER_INNER_HEIGHT_DEFAULT
            ? innerHeight
            : PAGE_HEADER_INNER_HEIGHT_DEFAULT;

    return {
        [theme.screen.laptop]: {
            position: 'sticky',
            zIndex: theme.siteVariables.zIndexes.topNav - 2,
            top: pxToRem(PAGE_HEADER_HEIGHT_EXPANDED * -1 + height),
            margin: pxArrayToRem([0, -50]),

            [`& > div`]: {
                boxShadow: isFloating
                    ? '0px 2px 24px 0px rgba(0, 0, 0, 0.10)'
                    : 'none',
            },
        },
    };
};

export const PageHeader: StyleRule = ({ theme }) => ({
    [theme.screen.laptop]: {
        minHeight: pxToRem(PAGE_HEADER_HEIGHT_EXPANDED),
        padding: pxArrayToRem([0, 50]),
        background: theme.siteVariables.colorScheme.default?.background,
        display: 'flex',
        alignItems: 'start',
        flexDirection: 'column',
    },
});
